import { Button, ButtonProps, cn } from "@tellescope/ui";
import { ArrowUpDown, Filter } from "lucide-react";

export interface ConfigureTableViewButtonProps extends Omit<ButtonProps, "children" | "variant" | "size"> {
  hasFilter: boolean;
  hasSorting: boolean;
}

export const ConfigureTableViewButton = ({
  hasFilter,
  hasSorting,
  className,
  ...rest
}: ConfigureTableViewButtonProps) => {
  const iconCount = hasSorting ? 2 : 1;

  return (
    <Button
      {...rest}
      variant="outline"
      size="icon"
      className={cn("px-2 transition-all flex gap-3", iconCount === 1 ? "w-9" : "w-[64px]", className)}
    >
      <div className="relative">
        <Filter />
        {hasFilter && <div className="absolute -top-1.5 -right-1.5 h-2 w-2 rounded-full bg-primary" />}
      </div>
      {hasSorting && (
        <div className="relative">
          <ArrowUpDown />
          <div className="absolute -top-1.5 -right-1.5 h-2 w-2 rounded-full bg-primary" />
        </div>
      )}
    </Button>
  );
};
